// Headline template per alert type — passed through t() so the factory sees
// alerts in Chinese. Placeholders are filled from the alert payload.
import { STAGE_LABEL } from "@/constants/roles";

export const ALERT_TEMPLATES = {
  pre_approval_overdue: "Pre-Order {po} — photos received, not approved in 2 days",
  factory_codes_overdue: "Factory codes missing on {po} for 2 days",
  production_overdue: "{po} not finished within 7 days — deadline {eta}",
  production_delay_notice: "{po} delayed — new ETA {eta}",
  production_eta_missed: "{po} missed new ETA {eta} — still in production",
  tracking_missing: "No tracking for {po} in 7 days",
  flagged_order: "Order {po} flagged",
  na_order: "Order {po} moved to NA",
  bad_photos: "📷 {po} sent back to Pre Orders — bad photos",
  after_sale_claim: "⚠️ AFTER-SALE QC · {po} · {detail}",
  claim_decided: "🛠 Claim decision · {po} · {detail}",
  order_reminder: "🔔 Reminder · {po} · {detail}",
  batch_unpaid_overdue: "Batch {date} unpaid for {days} days · ¥{amount}",
  batch_paid: "Batch {date} paid — ¥{amount}",
  packing_hold: "🛑 Packing issue on {po}",
  packing_hold_resolved: "🛑 Packing issue on {po}",
  hold_accepted: "✓ Issue accepted on {po} — continue packing",
  quality_control: "🔴 Quality Control · {po}",
  qc_send_back: "↩ Send {po} back to Factory — Quality Control",
  production_unsigned_48h: "{po} in production not signed for 48h",
  production_unprinted_48h: "{po} signed but not printed for 48h",
  extension_request: "⏰ {po} requests {days} more day(s)",
  extension_approved: "✓ {po} extension approved (+{days} days) — proceed",
  flag_resumed: "↩ {po} resumed from Flagged — continue at {stage}",
  reorder_approval: "🔁 {po} re-order approval needed — {reason}",
  store_in_warehouse: "📦 {po} — store in {warehouse} warehouse under Catalog # {cat} · {reason}",
  spare_parts: "🧩 {po} — put the set in SPARE PARTS ({warehouse}) · Catalog # {cat} · {reason}",
  production_needed: "🏭 PRODUCTION NEEDED — {po} not found in {warehouse} warehouse (CAT {cat} · {color}) — send to Production",
  cancel_stock_stop: "🛑 STOP — {po} stays in the {warehouse} warehouse · Catalog # {cat} · {color} on the box — confirm storage",
  ship_hold_stop: "🛑 STOP — {po} is ON HOLD · store in the {warehouse} warehouse (do not ship) · Catalog # {cat} · {color}",
  ship_hold_pending: "⏸ {po} ON HOLD — the STOP appears {detail}",
  cancel_stock_pending: "✕ {po} cancelled — set goes to {warehouse} stock · STOP after packing / on arrival",
  cancel_stock_missing_catalog: "⚠ {po} cancelled → stock but has NO Catalog # — add it so the station can confirm the STOP",
  ai_email_review: "✉️ {count} customer e-mail(s) waiting for your review in the AI Inbox",
};

export const ALERT_TYPE_LABEL = {
  pre_approval_overdue: "Pre-approval overdue",
  factory_codes_overdue: "Factory codes overdue",
  production_overdue: "Production overdue",
  production_delay_notice: "Production delay notice",
  production_eta_missed: "Production ETA missed",
  tracking_missing: "Tracking missing",
  flagged_order: "Flagged order",
  na_order: "NA order",
  bad_photos: "Bad photos",
  after_sale_claim: "After-sale QC claim",
  claim_decided: "Claim decision",
  order_reminder: "Order reminder",
  batch_unpaid_overdue: "Batch unpaid overdue",
  batch_paid: "Batch paid",
  packing_hold: "Packing hold",
  packing_hold_resolved: "Packing hold · accepted",
  hold_accepted: "Hold accepted",
  quality_control: "Quality control",
  qc_send_back: "QC send back",
  production_unsigned_48h: "Not signed 48h",
  production_unprinted_48h: "Not printed 48h",
  extension_request: "Extension request",
  extension_approved: "Extension approved",
  flag_resumed: "Resumed from Flagged",
  reorder_approval: "Re-order approval",
  store_in_warehouse: "Store in warehouse",
  spare_parts: "Spare parts",
  production_needed: "Production needed",
  cancel_stock_stop: "Cancelled — STOP",
  ship_hold_stop: "On hold — STOP",
  ship_hold_pending: "On hold",
  cancel_stock_pending: "Cancelled — stock pending",
  cancel_stock_missing_catalog: "Cancelled — Catalog # missing",
  ai_email_review: "AI e-mail review",
};

const shortMessage = (msg) => ((msg || "").split(/:\s|\s—\s|\.\s|\s\|\s/)[0] || msg || "").trim();

export function alertHeadline(a, t) {
  const tpl = ALERT_TEMPLATES[a?.type];
  if (!tpl) return shortMessage(a?.message);
  return t(tpl)
    .replace("{po}", a.po_number || "")
    .replace("{eta}", a.eta || "")
    .replace("{detail}", a.detail || "")
    .replace("{date}", a.batch_date || "")
    .replace("{days}", a.days ?? "")
    .replace("{amount}", a.amount ?? "")
    .replace("{color}", a.received_color || a.color || "—")
    .replace("{reason}", a.reason_label ? t(a.reason_label) : `${t("Wrong colour received")} (${a.received_color || a.color || "—"})`)
    .replace("{count}", a.count ?? "")
    .replace("{cat}", a.cat_number || "—")
    .replace("{warehouse}", String(a.warehouse || "china").toUpperCase())
    .replace("{stage}", a.stage ? t(STAGE_LABEL[a.stage] || a.stage) : "");
}

export function alertTypeLabel(a, t) {
  return t(ALERT_TYPE_LABEL[a?.type] || a?.type || "");
}
